import React from 'react'
import SiteUrlListTable from './SiteUrlListTable'
import SetTitle from '../../utils/set_title'
import auth from '../../auth/service'
import Header from '../../components/Headers/Header'

export default function SiteUrlList() {
  SetTitle('SEO Sentinel')

  const isWebranking = auth.userGroup === 'Webranking'
  const description = 'Lista di siti da monitorare.'

  return (
    <Header
      iconClass="ni ni-compass-04 text-white"
      title="SEO Sentinel"
      docLink={isWebranking ? '/docs/seo_monitoring_tool/seo_monitoring-setup/' : null}
      description={description}
    >
      <SiteUrlListTable />
    </Header>
  )
}